import {
  DeleteWithConfirmButton,
  Edit,
  SaveButton,
  SimpleForm,
  Toolbar,
  useRecordContext,
} from "react-admin";
import {
  DicomNodeClientFields,
  DicomNodeOutputOptionFields,
  DicomNodeGroupField,
  DicomNodeServerFields,
} from "./DicomNodeForm";

const EditToolbar = () => {
  const record = useRecordContext();

  return (
    <Toolbar>
      <SaveButton />
      <DeleteWithConfirmButton
        confirmContent="ra.confirm.delete"
        translateOptions={{ name: record.name }}
      />
    </Toolbar>
  );
};

export const DicomNodeEdit = () => (
  <Edit redirect="list" mutationMode="pessimistic">
    <SimpleForm toolbar={<EditToolbar />} mode="onBlur" reValidateMode="onBlur">
      <DicomNodeGroupField />
      <DicomNodeServerFields isEdit />
      <DicomNodeClientFields />
      <DicomNodeOutputOptionFields />
    </SimpleForm>
  </Edit>
);
